const GameCategories = {
  ADVANCED_DECODING: 'Advanced Decoding',
  ALL_GAMES: 'All Games',
  BOOKS: 'Books',
  CLOSE_READING: 'Close Reading',
  CRAFT_AND_STRUCTURE: 'Craft and Structure',
  EARLY_DECODING: 'Early Decoding',
  FLUENCY: 'Fluency',
  INTEGRATION_OF_KNOWLEDGE_AND_IDEAS: 'Knowledge and Ideas',
  KEY_IDEAS_AND_DETAILS: 'Key Ideas and Details',
  LETTER_COMBINATIONS: 'Letter Combinations',
  LETTER_SOUND_CORRESPONDENCE: 'Letter-Sound Correspondence',
  MICROCOMPREHENSION: 'Comprehension Processes',
  PHONICS: 'Phonics',
  PHONOLOGICAL_AWARENESS: 'Phonological Awareness',
  PROTOTYPES: 'Prototypes',
  VOCABULARY: 'Vocabulary',
  WEEKLY_USAGE: 'Weekly Game Usage',
};

export const categoriesOrder = [
  GameCategories.ALL_GAMES,
  GameCategories.PHONOLOGICAL_AWARENESS,
  GameCategories.LETTER_SOUND_CORRESPONDENCE,
  GameCategories.LETTER_COMBINATIONS,
  GameCategories.EARLY_DECODING,
  GameCategories.ADVANCED_DECODING,
  GameCategories.MICROCOMPREHENSION,
  GameCategories.KEY_IDEAS_AND_DETAILS,
  GameCategories.INTEGRATION_OF_KNOWLEDGE_AND_IDEAS,
  GameCategories.CRAFT_AND_STRUCTURE,
  GameCategories.VOCABULARY,
  GameCategories.FLUENCY,
  GameCategories.BOOKS,
  GameCategories.PROTOTYPES,
];

export const categoriesOrder45 = [
  GameCategories.WEEKLY_USAGE,
  GameCategories.CLOSE_READING,
  GameCategories.VOCABULARY,
  GameCategories.CRAFT_AND_STRUCTURE,
  GameCategories.INTEGRATION_OF_KNOWLEDGE_AND_IDEAS,
  GameCategories.KEY_IDEAS_AND_DETAILS,
  GameCategories.MICROCOMPREHENSION,
  GameCategories.PHONICS,
  GameCategories.PHONOLOGICAL_AWARENESS,
  GameCategories.FLUENCY,
  GameCategories.PROTOTYPES,
];

export default GameCategories;
